import { useQuery, UseQueryResult } from 'react-query';

import { getTokenWithType } from './useAuth';

import { xmlTags } from '../utils/urls';

import { ErrorModal } from 'types/modalTypes';

async function fetchXmlTags(): Promise<APIResult> {
  const response = await fetch(xmlTags, {
    method: 'GET',
    headers: {
      Authorization: getTokenWithType(),
    },
  });
  return response.json();
}

type TError = ErrorModal;

type APIResult = {
  isSuccess: boolean;
  StatusCode: number;
  Data: Array<string>;
};

type TResult = Array<{
  id: number;
  name: string;
}>;

function useGetXmlTags(): UseQueryResult<TResult, TError> {
  return useQuery(
    'get_xml_tags',
    async () => {
      const fetchResponse = await fetchXmlTags();
      const result = fetchResponse?.Data?.map((item, index) => ({
        id: index + 1,
        name: item,
      }));
      return result;
    },
    {
      staleTime: 60 * 1000,
      refetchOnWindowFocus: false,
    },
  );
}

export { useGetXmlTags };
